import { SkeletonLine, SkeletonContainer, baseSkeletonClasses } from "./SkeletonElements";

const PaymentDetailsSkeleton = () => {
    return (
        <div className="mb-8 grid grid-cols-1 md:grid-cols-6 gap-5">
            <div className="md:col-span-4 xl:col-span-5">
                <h3 className="text-primary text-2xl mb-4">
                    Plan contratado:{" "}
                    <span className={`inline-block h-6 w-30 ${baseSkeletonClasses} rounded`}></span>
                </h3>
                <SkeletonContainer className="space-y-4">
                    <SkeletonLine height="h-10" />
                    <SkeletonLine width="w-5/6" height="h-6" />
                    <SkeletonLine width="w-4/5" />
                    <SkeletonLine />
                </SkeletonContainer>
            </div>

            <div className="md:col-span-2 xl:col-span-1 flex">
                <div className="stats shadow-sm bg-base-200 text-center align-middle grow">
                    <div className="stat max-w-full">
                        <div className="stat-title text-primary text-xl break-words whitespace-normal">
                            Precio Final
                        </div>
                        <div className="stat-value break-words whitespace-normal">
                            <div
                                className={`h-10 ${baseSkeletonClasses} rounded w-16 mx-auto`}
                            ></div>
                        </div>
                        <div className="stat-desc break-words whitespace-normal">
                            Pago único mensual.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentDetailsSkeleton;
